module.exports = __webpack_public_path__ + "static/media/logo.3ea0cbe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/logo.svg
// module id = 168
// module chunks = 0